(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming_soon_page"]) return;
  try {
    
  function createRipple(x, y) {
      const ripple = document.createElement('div');
      ripple.classList.add('ripple');
      ripple.style.left = `${x}px`;
      ripple.style.top = `${y}px`;
      document.body.appendChild(ripple);

      ripple.addEventListener('animationend', () => {
          ripple.remove();
      });
  }

  document.addEventListener('mousemove', (e) => {
      createRipple(e.clientX, e.clientY);
  });

  document.addEventListener('touchstart', handleTouch);
  document.addEventListener('touchmove', handleTouch);

  function handleTouch(e) {
      e.preventDefault();
      const touch = e.touches[0];
      createRipple(touch.clientX, touch.clientY);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sphinx-main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Open popup
    document.querySelectorAll('.size-guide-trigger').forEach(button => {
      const popupId = button.getAttribute('data-popup-id');
      const popup = document.querySelector(`.size-guide-popup[data-popup-id="${popupId}"]`);
      
      if (popup) {
        const closeBtn = popup.querySelector('.button-close');

        button.addEventListener('click', () => {
          console.log("button");
          popup.classList.add('active');
          document.body.classList.add('no-scroll');
        });

        closeBtn?.addEventListener('click', () => {
          popup.classList.remove('active');
          document.body.classList.remove('no-scroll');
        });

        // Optional: Close when clicking outside the popup content
        popup.addEventListener('click', (e) => {
          if (e.target === popup) {
            popup.classList.remove('active');
            document.body.classList.remove('no-scroll');
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-customer-videos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const playButtons = document.querySelectorAll(".custom-play-button");

    let currentPlaying = {
      type: null,
      element: null,
      button: null
    };

    playButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const type = button.dataset.type;
        const wrapper = button.closest(".video-wrapper");

        // Remove is-playing class from all buttons
        playButtons.forEach(btn => btn.classList.remove("is-playing"));

        if (type === "html5") {
          const video = wrapper.querySelector("video[data-video]");

          if (!video.paused && !video.ended) {
            video.pause();
            currentPlaying = { type: null, element: null, button: null };
            button.classList.remove("is-playing");
          } else {
            // Pause other videos and YouTube iframes
            document.querySelectorAll("video[data-video]").forEach((v) => v.pause());
            document.querySelectorAll("iframe[data-video]").forEach((iframe) => {
              iframe.contentWindow.postMessage(
                '{"event":"command","func":"pauseVideo","args":""}',
                "*"
              );
            });

            video.play();
            button.classList.add("is-playing");
            currentPlaying = { type: "html5", element: video, button };
          }
        }

        if (type === "youtube") {
          const iframe = wrapper.querySelector("iframe[data-video]");
          let src = iframe.getAttribute("src");

          // Enable JS API if not already present
          if (!src.includes("enablejsapi=1")) {
            src += src.includes("?") ? "&enablejsapi=1" : "?enablejsapi=1";
            iframe.setAttribute("src", src);
          }

          if (
            currentPlaying.type === "youtube" &&
            currentPlaying.element === iframe
          ) {
            iframe.contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              "*"
            );
            button.classList.remove("is-playing");
            currentPlaying = { type: null, element: null, button: null };
          } else {
            // Pause other videos and iframes
            document.querySelectorAll("video[data-video]").forEach((v) => v.pause());
            document.querySelectorAll("iframe[data-video]").forEach((otherIframe) => {
              otherIframe.contentWindow.postMessage(
                '{"event":"command","func":"pauseVideo","args":""}',
                "*"
              );
            });

            iframe.contentWindow.postMessage(
              '{"event":"command","func":"playVideo","args":""}',
              "*"
            );
            button.classList.add("is-playing");
            currentPlaying = { type: "youtube", element: iframe, button };
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-faqs-with-category"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const tabTitles = document.querySelectorAll(".faq-tab-title");
    const tabContents = document.querySelectorAll(".faq-tab-content");
    const pageMainTitle = document.querySelector("#page-main-title");

    const select = document.querySelector(".select");
    const selectBtn = document.querySelector(".selectBtn");
    const selectOptions = document.querySelectorAll(".selectDropdown .option");

    function activateTab(slug) {
      tabTitles.forEach((t, index) => {
        const tabSlug = t.getAttribute("data-tab");
        const content = tabContents[index];

        if (tabSlug === slug) {
          t.classList.add("active");
          content.classList.add("active");

          if (pageMainTitle) {
            pageMainTitle.textContent = t.textContent.trim();
          }

          if (selectBtn) {
            selectBtn.textContent = t.textContent.trim();
            selectBtn.setAttribute("data-type", slug);
          }
        } else {
          t.classList.remove("active");
          content.classList.remove("active");
        }
      });
    }

    // Tab click
    tabTitles.forEach(tab => {
      tab.addEventListener("click", () => {
        const slug = tab.getAttribute("data-tab");
        const newUrl = new URL(window.location);
        newUrl.searchParams.set("faq", slug);
        window.history.replaceState({}, "", newUrl);
        activateTab(slug);
      });
    });

    // Dropdown behavior
    if (select && selectBtn) {
      selectBtn.addEventListener("click", () => {
        select.classList.toggle("toggle");
      });

      selectOptions.forEach(option => {
        option.addEventListener("click", () => {
          const slug = option.getAttribute("data-type");
          activateTab(slug);

          const newUrl = new URL(window.location);
          newUrl.searchParams.set("faq", slug);
          window.history.replaceState({}, "", newUrl);

          select.classList.remove("toggle");
        });
      });

      // Close dropdown on outside click
      document.addEventListener("click", e => {
        if (!select.contains(e.target)) {
          select.classList.remove("toggle");
        }
      });
    }

    // On page load, activate correct tab
    const urlParams = new URLSearchParams(window.location.search);
    const tabFromUrl = urlParams.get("faq");

    if (tabFromUrl) {
      activateTab(tabFromUrl);
    } else if (tabTitles.length > 0) {
      activateTab(tabTitles[0].getAttribute("data-tab"));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-featured-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const totalSlides = document.querySelectorAll('.collection-image-swiper .swiper-slide').length;
    console.log(totalSlides);

    const imgSwiper = new Swiper('.collection-image-swiper', {
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      loopedSlides: totalSlides,
      // autoplay: {
      //  delay: 4000,
      // },
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 500,
      watchSlidesProgress: true,
    });

    const infoSwiper = new Swiper('.collection-info-swiper', {
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      loopedSlides: totalSlides,
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 500,
    });

    const namesSwiper = new Swiper('.collection-names-swiper', {
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      loopedSlides: totalSlides,
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 500,
    });

    // Next/Prev button custom control
    const nextBtn = document.querySelector('.swiper-button-next');
    const prevBtn = document.querySelector('.swiper-button-prev');

    nextBtn.addEventListener('click', () => {
      if (!imgSwiper.animating) imgSwiper.slideNext();
    });

    prevBtn.addEventListener('click', () => {
      if (!imgSwiper.animating) imgSwiper.slidePrev();
    });

    // Tab click: slide all swipers and set active tab
    const tabs = document.querySelectorAll('.collection-tab');
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        imgSwiper.slideToLoop(index);
        // infoSwiper & namesSwiper sync handled by slideChange
      });
    });

    // Sync infoSwiper and namesSwiper when imgSwiper changes
    imgSwiper.on('slideChange', () => {
      const activeIndex = imgSwiper.realIndex;

      infoSwiper.slideToLoop(activeIndex);
      namesSwiper.slideToLoop(activeIndex);

      // Update tab UI
      const activeCollectionId = imgSwiper.slides[imgSwiper.activeIndex].getAttribute('data-collection');
      tabs.forEach(t => {
        t.classList.toggle('active', t.getAttribute('data-collection') === activeCollectionId);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-images-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiperEl = document.querySelector('.gallerySwiper');
    if (!swiperEl) return;

    const autoplay = swiperEl.dataset.autoplay === "true";
    const autoplayDelay = parseInt(swiperEl.dataset.autoplayDelay) || 3000;
    const loop = swiperEl.dataset.loop === "true";
    const desktopSlides = parseInt(swiperEl.dataset.desktopSlides) || 3;
    const mobileSlides = parseInt(swiperEl.dataset.mobileSlides) || 1;

    const swiperConfig = {
      loop: loop,
      slidesPerView: desktopSlides,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: mobileSlides
        },
        768: {
          slidesPerView: desktopSlides
        }
      }
    };

    if (autoplay) {
      swiperConfig.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false
      };
    }

    new Swiper('.gallerySwiper', swiperConfig);
  });

  } catch(e) { console.error(e); }
})();
})();
